import { init } from '@sentry/vue';
import { getRegisterConfig } from '@golden/sentry-base';
export const registerSentry = (options) => {
    const { app, ignoreErrors = [] } = options;
    init({
        ...getRegisterConfig(options),
        app,
        logErrors: true,
        tracesSampleRate: 0.001,
        tracingOptions: {
            trackComponents: true
        },
        ignoreErrors,
        denyUrls: [
            /chrome-extension:\/\//,
            /moz-extension:\/\//,
            /safari-extension:\/\//,
            /extensions\//i,
            /^chrome:\/\//i
        ]
    });
};
//# sourceMappingURL=registerSentry.js.map